import { Component, OnInit } from '@angular/core';
import { SalesService } from '../sales.service';
import { ActivatedRoute } from '@angular/router';
import { CommonService, DocumentsService, RestService } from '../../../services/common';
import { forkJoin } from 'rxjs/internal/observable/forkJoin';
import { BloodGroup } from '../../../../appconfig';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-allotment',
  templateUrl: './allotment.component.html',
  styleUrl: './allotment.component.scss'
})
export class AllotmentComponent implements OnInit {
  showaddUpdateModal: boolean = false;
  UnitCategoryList: any;
  UnitDescriptionList: any;
  allotmentSupportData: any;
  paymentPlanList: any;
  sourceNamrList: any;
  bookingId!: number;
  allotmentId: any;
  nameInitialList: any;
  relationInitialList: any;
  bloodGroupList: any;
  sourceTypeList: any;
  amountTypeList: any;
  documentTypeList: any;
  amountSubTypeAgainstProject: any;
  taxSubTypeList: any;
  allotmentList: any;
  private destroy$ = new Subject<void>();

  constructor(private salesService: SalesService, private route: ActivatedRoute, private documentService: DocumentsService,
    private commonService: CommonService) {
  }

  ngOnInit(): void {
    //Validating if user comes from booking to allotment transfer.
    if (this.salesService?.currentBooking?.id > 0) {
      this.bookingId = this.salesService?.currentBooking?.id;
    }

    this.allotmentId = this.route.snapshot.paramMap.get("allotmentId")!;
    this.getAllotmentData();
  }

  RefreshBasicEntityLists() {
    forkJoin([this.salesService.getUnitCategory(),
    this.salesService.getpaymentPlan(),
    this.salesService.getMasterDataByType('name'),
    this.salesService.getMasterDataByType("relation"),
    this.salesService.getUserSubType(),
    this.salesService.getUnitDescription(),
    this.salesService.getAmountType(),
    this.documentService.getDocumentType(),
    this.salesService.getAmountSubTypeAgainstProjectId(),
    this.salesService.getTaxSubType()
    ]).subscribe(
      ([UnitCategory, paymentPlans, nameInitials, relationInitials, sourceType, unitDescription, amountType, documentType,
        amountSubTypeAgainstProject, taxSubType]) => {
        this.UnitCategoryList = UnitCategory?.result;
        this.paymentPlanList = paymentPlans?.result;
        this.nameInitialList = nameInitials?.result;
        this.relationInitialList = relationInitials?.result;
        this.sourceTypeList = sourceType?.result;
        this.UnitDescriptionList = unitDescription?.result;
        this.amountTypeList = amountType?.result;
        this.documentTypeList = documentType?.result;
        this.amountSubTypeAgainstProject = amountSubTypeAgainstProject?.result;
        this.taxSubTypeList = taxSubType.result;
        this.bloodGroupList = Object.values(BloodGroup)

        if (this.bookingId) {
          let modeldata = {
            showaddUpdateModal: true,
            currentSelectedRecord: this.salesService?.currentBooking
          }
          this.changeAddUpdateModelState(modeldata)
        }
      })
  };

  changeAddUpdateModelState(allotmentModal: any) {
    if (allotmentModal?.showaddUpdateModal) {
      this.allotmentSupportData = {
        "currentRecord": (this.bookingId == undefined || this.bookingId == null) ? allotmentModal?.currentSelectedRecord : this.convertBookingToAllotmentObject(allotmentModal?.currentSelectedRecord),
        "unitCategoryList": this.UnitCategoryList,
        "paymentPlanList": this.paymentPlanList,
        "agentList": null,
        "nameInitialsList": this.nameInitialList,
        "relationInitialList": this.relationInitialList,
        "sourceTypeList": this.sourceTypeList,
        "unitDescriptionList": this.UnitDescriptionList,
        "amountTypeList": this.amountTypeList,
        "documentTypeList": this.documentTypeList,
        "amountSubTypesAgainstProject": this.amountSubTypeAgainstProject,
        "taxSubTypeList": this.taxSubTypeList,
        bloodGroupList: this.bloodGroupList
      }
    }
    this.commonService?.selectTab(0);
    this.showaddUpdateModal = allotmentModal.showaddUpdateModal;
    if (allotmentModal.isCancelled) {
      this.getAllotmentData();
    }
  }

  private convertBookingToAllotmentObject(bookingObject: any) {
    return {
      clientDetail: {
        firstName: bookingObject?.clientDetail?.firstName,
        lastName: bookingObject?.clientDetail?.lastName,
        nameInitialsId: bookingObject?.clientDetail?.nameInitialsId,
        relationInitialsId: bookingObject?.clientDetail?.relationInitialsId,
        fatherHusbandName: bookingObject?.clientDetail?.fatherHusbandName,
        email: bookingObject?.clientDetail?.email,
        gender: bookingObject?.clientDetail?.gender,
        dateOfBirth: bookingObject?.clientDetail?.dateOfBirth,
        primaryPhoneNo: bookingObject?.clientDetail?.primaryPhoneNo,
        nationality: bookingObject?.clientDetail?.nationality,
        aadharNumber: bookingObject?.clientDetail?.aadharNumber,
        documentNumber: bookingObject?.clientDetail?.panCardNo,
        id: bookingObject?.clientDetail?.id,
      },
      sourceDetail: {
        id: bookingObject?.sourceDetail?.id,
        userSubTypeId: bookingObject?.sourceTypeDetail?.id,
      },
      basicSalePrice: bookingObject?.rateOffered,
      bookingDate: bookingObject?.bookingDate,
      paymentPlanId: bookingObject?.paymentPlanDetail?.id,
      previousBookingId: bookingObject?.id,

      unitDescriptionDetails: {
        // id: bookingObject?.bookingDate,
        unitCategoryId: bookingObject?.unitCategoryDetail?.id,
      },
      // unitDescriptionDetails: {
      //   bookingDate: bookingObject?.bookingDate,



      // }
    }
  }
  closeAllotmentDialogue() {
    //need to check if any data is submitted then list is refresh.
  }

  getAllotmentData() {
    this.commonService.selectedProjects$.pipe(takeUntil(this.destroy$)).subscribe((selectedProject: any) => {
      this.allotmentList = [];
      if (selectedProject != null) {
        //Getting all data for basic entity required for create allotment.
        this.RefreshBasicEntityLists();
        //"allotment?projectId=" + selectedProject?.id
        this.salesService.filterAllotment(this.allotmentId, selectedProject?.id).subscribe((res: any) => {
          this.allotmentList = res?.result?.map((data: any) => {
            data.percentageAmount = data?.totalAmount && parseFloat(data.totalAmount) !== 0
              ? ((data?.recivedAmount * 100) / parseFloat(data?.totalAmount)).toFixed(2)
              : "0.00"; // Default value when totalAmount is 0 or undefined
            data.amount = data?.totalAmount?.toLocaleString('en-IN');
            let formattedReceivedAmount = data?.recivedAmount?.toLocaleString('en-IN');
            data.recivedAmount = formattedReceivedAmount;
            if (data?.unitDescriptionDetails?.unitCategory) {
              data.product = data?.unitDescriptionDetails?.unitCategory?.name;
              data.unitNo = data?.unitDescriptionDetails?.name;
            }
            if (data.clientDetail) {
              data["clientName"] = data?.clientDetail?.nameInitial?.name + '.' + ' ' + data?.clientDetail?.firstName + ' ' + data?.clientDetail?.lastName;
            }
            data.contactNumber = data?.clientDetail?.primaryPhoneNo?.replace(/(\d{5})(\d{5})/, '$1-$2');
            if (data.sourceDetail) {
              data["sourceName"] = data?.sourceDetail?.nameInitial?.name + '.' + ' ' + data?.sourceDetail?.firstName + ' ' + data?.sourceDetail?.lastName;
            }
            if (data?.unitDescriptionDetails) {
              data.unitDescription = data?.unitDescriptionDetails?.name;
              data.unitCategory = data?.unitDescriptionDetails?.unitCategory?.name;
            }
            return data;
          })
        });
      }
    })
  }
  ngOnDestroy(): void {
    // Signal completion to clean up subscriptions
    this.destroy$.next();
    this.destroy$.complete();
  }
}
